import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { CloudFunctionsApiService } from './cloud-functions-api.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  uid = null;

  constructor(
    private angularFireAuth: AngularFireAuth,
    private api: CloudFunctionsApiService
  ) {
    this.angularFireAuth.authState.subscribe((user) => {
      this.uid = user ? user.uid : null;
    });
  }

  loginWithEmail(email: string, password: string) {
    return this.angularFireAuth.signInWithEmailAndPassword(email, password);
  }

  loginWithSAML(provider) {
    return this.angularFireAuth.signInWithPopup(provider);
  }

  registerWithEmail(email: string, password: string) {
    return this.angularFireAuth.createUserWithEmailAndPassword(email, password);
  }

  getStatus() {
    return this.angularFireAuth.authState;
  }

  logOut() {
    return this.angularFireAuth.signOut();
  }

  getCurrentUserID() {
    return this.uid;
  }

  isUserAdmin(uid) {
    return this.api.valueList(`/users?uid=${encodeURIComponent(uid)}`);
  }

  isUserAdminBueno(uid) {
    return this.api.valueList(`/users?uid=${encodeURIComponent(uid)}&role=admin`);
  }

  getUserByUid(uid: string) {
    return this.api.valueList(`/users?uid=${encodeURIComponent(uid)}`);
  }

  isAuth() {
    return this.angularFireAuth.authState.pipe(map((auth) => auth));
  }

  updatepass(user) {
    return user
      .updatePassword('canchilas')
      .then(function () {})
      .catch(function () {});
  }

  async sendEmailverification() {
    (await this.angularFireAuth.currentUser).sendEmailVerification();
  }

  async resetemail(email) {
    await this.angularFireAuth.sendPasswordResetEmail(email);
  }
}
